import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {endpoints} from '../../../core/configs/endpoints';

@Injectable({providedIn: 'root'})
export class FlowApiService {
  private readonly _httpClient = inject(HttpClient);

  getAvailableVersions() {
    return this._httpClient.get<{
      name: string;
      major: number;
      minor: number;
      state: 'valid' | 'obsolete' | 'invalid';
      final_validity_date?: string;
    }[]>(
      `${endpoints.app.version}`
    );
  }

}
